import React, { FC }             from "react";
import { useDispatch, useStore } from "react-redux";
import { Button, Icon }          from "semantic-ui-react";
import UpdateRecordTemplate      from "../../../../application/usecase/record/template/UpdateRecordTemplate";
import RecordTemplate            from "../../../../domain/record/template/RecordTemplate";

const RecordTemplateUpdateButton: FC = () => {
  const updateRecordTemplate: UpdateRecordTemplate = new UpdateRecordTemplate(useDispatch());
  const template: RecordTemplate = useStore().getState().template;
  return (
    <>
      <Button
        icon
        labelPosition="left"
        positive
        onClick={ () => updateRecordTemplate.execute(template) }
      >
        <Icon name="save"/>保存する
      </Button>
    </>
  );
};

export default RecordTemplateUpdateButton;
